import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Rookie',
  price: 'Free',
  description: 'Taste the asphalt.',
  features: ['Basic Access', '720p Streaming', 'Community Forums', 'Ad-supported'],
  cta: 'Start Free',
  variant: 'ghost' as const
}, {
  name: 'Pro',
  price: '€9.99',
  period: '/mo',
  description: 'For the serious contender.',
  features: ['Unlimited 4K Streams', 'Tournament Entry', 'Creator Tools', 'Ad-free Experience', 'Replay Analysis'],
  cta: 'Go Pro',
  variant: 'primary' as const,
  popular: true
}, {
  name: 'Elite',
  price: '€24.99',
  period: '/mo',
  description: 'Dominate the leaderboard.',
  features: ['Everything in Pro', '1-on-1 Coaching', 'Exclusive Events', 'Revenue Share Program', 'Priority Support', 'Merch Discounts'],
  cta: 'Join Elite',
  variant: 'outline' as const
}];
export function Pricing() {
  return <section className="bg-neutral-950 py-24 relative" data-id="element-125">
      <div className="container mx-auto px-4" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-4xl md:text-6xl font-black text-white uppercase italic tracking-tighter mb-4" data-id="element-128">
            Choose Your <span className="text-red-600" data-id="element-129">Class</span>
          </h2>
          <p className="text-neutral-400 max-w-xl mx-auto" data-id="element-130">
            Whether you're watching from the sidelines or tearing up the track,
            we have a plan for you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-131">
          {plans.map((plan, index) => <div key={index} className={`relative p-8 border ${plan.popular ? 'bg-neutral-900 border-red-600 z-10 scale-105 shadow-[0_0_50px_rgba(220,38,38,0.2)]' : 'bg-neutral-950 border-neutral-800'} flex flex-col`} data-id="element-132">
              {plan.popular && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-600 text-white text-xs font-bold uppercase tracking-widest py-1 px-3 skew-x-[-10deg]" data-id="element-133">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-134">
                <h3 className="text-2xl font-black text-white uppercase italic mb-2" data-id="element-135">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-136">
                  <span className="text-4xl font-black text-white" data-id="element-137">
                    {plan.price}
                  </span>
                  {plan.period && <span className="text-neutral-500" data-id="element-138">{plan.period}</span>}
                </div>
                <p className="text-neutral-400 text-sm mt-4" data-id="element-139">
                  {plan.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-140">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-neutral-300" data-id="element-141">
                    <Check className="w-5 h-5 text-red-600 shrink-0" data-id="element-142" />
                    {feature}
                  </li>)}
              </ul>

              <Button variant={plan.variant} className="w-full" data-id="element-143">
                {plan.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}